import { HERO_TONE } from '@tonnie/design-tokens';
import { HERO_CLASSES } from '@tonnie/ui';

/**
 * InOut's colour — the hero's tone, as on its band and in the public
 * calculator: every primary action of InOut (save, confirm, pay, book) wears
 * it (`<Button tone={INOUT_TONE}>`), so an action does not change colour when
 * a dialog opens; so does the chosen segment of a choice
 * (`<ToggleGroup tone={INOUT_TONE} fit>`). On Citizen Web the whole hero —
 * its page and every dialog, menu and popover opened from it — is a
 * `<ToneScope tone={INOUT_TONE}>` (owner, 19 Oct 2026: D2), so checks, radios,
 * the calendar's day, links and the focus ring wear it too. A portal's look
 * overrides the tone's variables, so the same code wears Ei!'s gold on its
 * portal.
 */
export const INOUT_TONE = HERO_TONE.inout;

/**
 * InOut's colour as classes — an icon, a tint, a line, a fill: the hero's,
 * never a colour named in the code ("cyan"), so the screens follow the hero's
 * tone and a portal's look.
 */
export const INOUT_CLASSES = HERO_CLASSES.inout;
